/**
 * Nav.jsx
 * nav bar for page while logged out
 * import NavLink from react bootstrap for styling
 */
import React from 'react';
import {NavLink} from "react-router-dom";
import '../../style/nav.css';


function Nav() {
    return (
        <div>
            <div id="head">
                <h1 id="headp">LINK2RSVP</h1>
                <div id="navbar-nav">
                <NavLink to="/" activeClassName="active" exact={true} className="nav-item">
                    About 
                </NavLink>
                <NavLink to="/contact" activeClassName="active" className="nav-item">
                    Contact 
                </NavLink>
                <NavLink to="/login" activeClassName="active" className="nav-item">
                    Login
                </NavLink>
                </div>
            </div>
        </div>
    );
}

export default Nav;